import React, { useState } from "react";
import logoSm from "../../../assets/landing-page/logo-sm.png";

const formatTime = (timestamp) => {
  const d = new Date(timestamp);
  return d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
};

const UserBubble = ({ message, onEdit }) => {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      className="flex items-end gap-2 justify-end animate-fadeIn"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {/* Edit button — visible on hover */}
      <button
        onClick={() => onEdit(message)}
        className={`text-gray-400 hover:text-gray-600 transition-opacity text-xs p-1 ${
          hovered ? "opacity-100" : "opacity-0"
        }`}
        title="Edit message"
        aria-label="Edit message"
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
        </svg>
      </button>

      <div className="flex flex-col items-end gap-1" style={{ maxWidth: "75%" }}>
        <div className="text-white px-4 py-3 rounded-2xl rounded-br-sm shadow-sm text-sm leading-relaxed" style={{ backgroundColor: "#0d9488" }}>
          {message.text}
        </div>
        <span className="text-gray-400 px-1 text-left" style={{ fontSize: "10px" }}>{formatTime(message.timestamp)}</span>
      </div>

      {/* User avatar */}
      <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center flex-shrink-0 shadow text-gray-500">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z"/>
        </svg>
      </div>
    </div>
  );
};

const AssistantBubble = ({ message }) => (
  <div className="flex items-end gap-3 justify-start animate-fadeIn">
    {/* Alysei avatar */}
    <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 overflow-hidden shadow" style={{ backgroundColor: "#0d9488" }}>
      <img src={logoSm} alt="Alysei AI" className="w-5 h-5 object-contain" />
    </div>

    <div className="flex flex-col gap-1" style={{ maxWidth: "75%" }}>
      <div className="bg-white border border-gray-100 shadow-sm px-4 py-3 rounded-2xl rounded-bl-sm text-sm text-gray-800 leading-relaxed whitespace-pre-wrap">
        {message.text}
      </div>
      <span className="text-gray-400 px-1 text-left" style={{ fontSize: "10px" }}>{formatTime(message.timestamp)}</span>
    </div>
  </div>
);

const MessageBubble = ({ message, onEdit }) => {
  if (message.role === "user") {
    return <UserBubble message={message} onEdit={onEdit} />;
  }
  return <AssistantBubble message={message} />;
};

export default MessageBubble;
